import moment from "moment";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// component
import AuthService from "Lib/API/Auth";
import AlertDialog from "components/Dialog";
import Button from "components/button/Button";
import MainTabs from "components/mainTabs/MainTabs";
import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
// direct import
import "./index.scss";
import CurrentForms from "./CurrentForms";
import MembersForms from "./membersForm/index";
import { SubHeader } from "../../layout/SubHeader";
import { addObject, changeStatus } from "./CreateForm/formSlice";

const initialFilters = {
  sort: {},
  search: undefined,
};

export const Forms = ({ ...props }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [tabValue, setTabValue] = useState("active");
  const isMembershipTab = tabValue === "membership";
  const isArchivedTab = tabValue === "archived";
  const organization = JSON.parse(localStorage.getItem("organization")) || {};

  const [newClassName, setNewClassName] = useState("");
  const [error, setError] = useState("");
  const [duplicate, setDuplicate] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [data, setData] = useState({});
  const [added, setAdded] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [classesCount, setClassesCount] = useState(0);
  const [datePaid, setPaidRange] = useState([null, null]);
  const [startPaidDate, endPaidDate] = datePaid;
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [filters, setFilters] = useState(initialFilters);
  const [searchValue, setSearchValue] = useState("");
  const [activeFormPage, setActiveFormPage] = useState(0);
  const [archivedClassPage, setArchivedClassPage] = useState(0);
  const [sorting, setSorting] = useState({
    sort: {},
    search: undefined,
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const key = new URLSearchParams(location.search).get("key");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (key) {
      setTabValue(key);
      searchParams.delete("key");

      history.replace({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
    }
  }, [key]);

  const handleCloseDialog = () => setOpenDialog(false);

  const handleSort = (name) => {
    setSorting((prev) => ({
      ...prev,
      sort: {
        [name]: prev.sort[name] === 1 ? -1 : 1,
      },
    }));
  };

  useEffect(() => {
    if (searchValue === "") {
      setSorting((prev) => ({ ...prev, search: undefined }));
    } else {
      setSorting((prev) => ({ ...prev, search: searchValue }));
    }
    if (tabValue === "active") setActiveFormPage(0);
    else if (tabValue === "archived") setArchivedClassPage(0);
  }, [searchValue]);

  useEffect(() => {
    if (startDate && endDate) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          charge_date: {
            start: moment(startDate).format("MM/DD/YYYY"),
            end: moment(endDate).format("MM/DD/YYYY"),
          },
        },
      }));
    } else if (!startDate && !endDate) {
      setFilters({
        sort: {},
        search: filters?.search,
      });
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startPaidDate && endPaidDate) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          paid_at: {
            start: moment(startPaidDate).format("MM/DD/YYYY"),
            end: moment(endPaidDate).format("MM/DD/YYYY"),
          },
        },
      }));
    } else if (!startPaidDate && !endPaidDate) {
      setFilters({
        sort: {},
        search: filters?.search,
      });
    }
  }, [startPaidDate, endPaidDate]);

  const sortCharged = (e) => {
    setFilters((prev) => ({
      ...prev,
      sort: {
        [e]: prev.sort[e] === 1 ? -1 : 1,
      },
    }));
  };

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();
    try {
      const res = await AuthService.postDuplicate(data, token);
      if (res) {
        setAdded(!added);
        setOpenDialog(false);
      }
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };

  const formTabs = [
    { id: "active", title: "Active", value: "active", width: "80px" },
    { id: "archived", title: "Archived", value: "archived", width: "140px" },
    ...(organization?.allowMembership
      ? [
          {
            id: "membership",
            title: "Membership",
            value: "membership",
            width: "126px",
          },
        ]
      : []),
  ];

  return (
    <div className="school-classes pt-5">
      <div className="header mt-5">
        <div className="header-tittle">
          <SubHeader
            className="class-tab subheader"
            title={
              isArchivedTab
                ? "Archived Forms"
                : isMembershipTab
                ? "Membership Forms"
                : "Forms"
            }
          />
        </div>
        {!isMembershipTab ? (
          <div className="new-class">
            <Button
              variant="primary"
              onClick={() => {
                history.push("/create-new-form");
                dispatch(changeStatus("create"));
                dispatch(addObject([]));
              }}
            >
              <PlusIcon />
              <span>Add New Form</span>
            </Button>
          </div>
        ) : (
          <div className="new-class">
            <Button
              variant="primary"
              onClick={() => {
                history.push("/create-membership-form");
              }}
            >
              <PlusIcon />
              <span>Add Membership Form</span>
            </Button>
          </div>
        )}
      </div>

      <MainTabs
        className="mt-10"
        tabs={formTabs}
        activeTab={tabValue}
        onTabsChange={(tab) => setTabValue(tab?.value)}
      />

      {isMembershipTab ? (
        <MembersForms
          added={added}
          setClassesCount={setClassesCount}
          setDisabled={setDisabled}
          setData={setData}
          setOpenDialog={setOpenDialog}
          newClassName={newClassName}
          setError={setError}
          archived={isArchivedTab}
          duplicate={duplicate}
          sortCharged={sortCharged}
          handleSort={handleSort}
          handleInputChange={handleInputChange}
          searchValue={searchValue}
          toggle={tabValue === "active"}
          activeFormPage={activeFormPage}
          setActiveFormPage={setActiveFormPage}
          archivedClassPage={archivedClassPage}
          setArchivedClassPage={setArchivedClassPage}
        />
      ) : (
        <div>
          <CurrentForms
            added={added}
            setClassesCount={setClassesCount}
            setDisabled={setDisabled}
            setData={setData}
            setOpenDialog={setOpenDialog}
            newClassName={newClassName}
            setError={setError}
            archived={isArchivedTab}
            duplicate={duplicate}
            sortCharged={sortCharged}
            handleSort={handleSort}
            setSorting={setSorting}
            sorting={sorting}
            handleInputChange={handleInputChange}
            searchValue={searchValue}
            toggle={tabValue === "active"}
            activeFormPage={activeFormPage}
            setActiveFormPage={setActiveFormPage}
            archivedClassPage={archivedClassPage}
            setArchivedClassPage={setArchivedClassPage}
          />
        </div>
      )}

      <AlertDialog
        handleClose={handleCloseDialog}
        open={openDialog}
        onDecline={() => setOpenDialog(false)}
        onAccept={() => {
          if (newClassName) handleSubmit();
        }}
        title="Are you sure?"
      />
    </div>
  );
};
